var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h500v500H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h500v500H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#b)",
    style: {
      display: "block"
    },
    transform: "rotate(45.892 202.197 271.64) scale(.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B10000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.34,
    d: "M-19.071 18.564c.1-.106.202-.211.306-.315l36.426-36.426.194-.191",
    style: {
      display: "block"
    },
    transform: "rotate(180 125 125) scale(3.74)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C1C2B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M155.006 134.761C186.39 98.693 205.393 51.565 205.393 0c0 0 0 0 0 0 0-61.87-27.356-117.35-70.632-155.006",
    style: {
      display: "block"
    },
    transform: "rotate(45.892 -171.83 423.167) scale(.89)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C1C2B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M155.006 134.761C186.39 98.693 205.393 51.565 205.393 0c0 0 0 0 0 0 0-61.87-27.356-117.35-70.632-155.006",
    style: {
      display: "block"
    },
    transform: "rotate(135.892 74.757 176.975) scale(.89)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C1C2B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M155.006 134.761C186.39 98.693 205.393 51.565 205.393 0c0 0 0 0 0 0 0-61.87-27.356-117.35-70.632-155.006",
    style: {
      display: "block"
    },
    transform: "rotate(-134.108 179.153 72.746) scale(.89)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C1C2B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 14,
    d: "M155.006 134.761C186.39 98.693 205.393 51.565 205.393 0c0 0 0 0 0 0 0-61.87-27.356-117.35-70.632-155.006",
    style: {
      display: "block"
    },
    transform: "rotate(-44.108 436.842 -184.53) scale(.89)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "com",
    style: {
      display: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", null)), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", null)), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", null)), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", null)), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", null)), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", null)), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", null)), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", null)), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", null)), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", null)), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", null)), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", null)))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ead532590d029f1cc888face67db142f.svg";
export { ForwardRef as ReactComponent };